

<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <UsuarioRegister></UsuarioRegister>
</v-col>
</v-row>  


<v-row justify="end" >
        
        <v-col cols="2" >





        </v-col>
      </v-row>



</v-container>
   
</div>
</template>

<script>

import UsuarioRegister from '@/components/auto_register/UsuarioRegister.vue';


export default {
    data () {
    return {
              
    }
  },
  components: {
    
    UsuarioRegister
    
  },

  methods: {

}

}
    

</script>


